import React, { Component } from 'react';
import cn from 'classnames/bind';
import styles from './Switcher.scss';
import { Motion, spring } from 'react-motion';
import tracker from '../../../services/tracker';

let cx = cn.bind(styles);

export default class Switcher extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isChecked: ('defaultChecked' in this.props) ? this.props.defaultChecked : true
    };

    this.handleClick = this.handleClick.bind(this);
  }

  renderButton(icon, text, elementStyle, textStyle, isChecked, style) {
    return (
        <div className={cx({ Button: true, [elementStyle]: true })} style={style}>
          {icon}<span className={cx({ [textStyle]: true })}>{text}</span>
        </div>
    );
  }

  handleClick() {
    const { onClick, events, eventData } = this.props;

    this.setState({ isChecked: !this.state.isChecked }, () => {
      tracker.sendEvent(this.state.isChecked ? events.left : events.right, eventData);
      onClick(this.state.isChecked);
    });
  }

  render() {
    const {
        className,
        enabledElemStyle,
        enabledColor,
        elementStyle,
        textStyle,
        leftIcon,
        rightIcon,
        leftText,
        rightText,
        tooltipLeft,
        tooltipRight,
        chessfilter
    } = this.props;

    return (
          <button
            className={cx(className, styles.Buttons, {[styles.ButtonsСhessfilter]: chessfilter})}
            onClick={this.handleClick}
            data-tip={this.state.isChecked ? tooltipLeft : tooltipRight}
            data-for="global"
          >
            {chessfilter ? (
                this.renderButton(leftIcon, leftText, elementStyle, textStyle, this.state.isChecked, {
                  color: this.state.isChecked ? (enabledColor ? enabledColor :'white') : 'rgba(0, 0, 0, 0.8)',
                  opacity: 1
                })
            ) : (
                <Motion style={{x: spring(this.state.isChecked ? 1 : 0.5)}}>
                  {({x}) =>
                      this.renderButton(leftIcon, leftText, elementStyle, textStyle, this.state.isChecked, {
                        color: x < 0.75 ? 'rgba(55, 45, 45, 0.5)' : (enabledColor ? enabledColor :'white'),
                        opacity: 1
                      })
                  }
                </Motion>
            )}

            { chessfilter ? (
              this.renderButton(rightIcon, rightText, elementStyle, textStyle, !this.state.isChecked, {
                color: !this.state.isChecked ? (enabledColor ? enabledColor :'white') : 'rgba(0, 0, 0, 0.8)',
                opacity: 1
              })
            ) : (
                <Motion style={{x: spring(this.state.isChecked ? 0.5 : 1)}}>
                  {({x}) =>
                      this.renderButton(rightIcon, rightText, elementStyle, textStyle, !this.state.isChecked, {
                        color: x < 0.75 ? 'rgba(55, 45, 45, 0.5)' : (enabledColor ? enabledColor :'white'),
                        opacity: 1
                      })
                  }
                </Motion>
            )}

            {chessfilter ? (
              <div
                className={cx(enabledElemStyle, styles.EnabledElement)}
                style={{
                  left: 0,
                  WebkitTransform: `translate3d(${this.state.isChecked ? '100' : 0}%, 0, 0)`,
                  transform: `translate3d(${this.state.isChecked ? '100' : 0}%, 0, 0)`,
                }}
              />
            ) : (
                <Motion style={{x: spring(this.state.isChecked ? 0 : 100)}}>
                  {({x}) =>
                      <div
                          className={cx(enabledElemStyle, styles.EnabledElement)}
                          style={{
                            left: 0,
                            WebkitTransform: `translate3d(${x}%, 0, 0)`,
                            transform: `translate3d(${x}%, 0, 0)`,
                          }}
                      />
                  }
                </Motion>
            )}

          </button>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/common/Switcher/Switcher.js